/**
 * Bigfoot — „Robin Hood vs. Bigfoot".
 *
 * Postava stojí na tom, že sa hýbe cez cudzie figúrky a bije všetko okolo seba.
 * Schopnosť LONER BY NATURE ho odmeňuje za samotu na konci ťahu.
 */

import { askChoice, dealDamage, drawCard, getMap, heroOf } from '../ops.js';
import { shareZone } from '../map.js';
import { adjacentFighters, askMove, emptySpacesInZone, fighterOrNull } from './helpers.js';
import { disengage, feint, momentousShift, regroup, skirmish } from './common.js';
import type { CardEffect, EffectRegistry, HeroSpecial } from './types.js';

/** „Move Bigfoot up to 5 spaces … through spaces containing opposing fighters." */
const crashThroughTheTrees: CardEffect = {
  scheme: (e) => {
    if (!e.fighterId) return;
    askMove(e, {
      fighters: [e.fighterId],
      max: 5,
      through: true,
      label: 'Presuň Bigfoota až o 5 priestorov (smie prejsť cez súperove figúrky)',
    });
  },
};

/** „If you won the combat, deal 1 damage to each fighter adjacent to Bigfoot." */
const savagery: CardEffect = {
  after: (e) => {
    if (!e.won) return;
    const bigfoot = fighterOrNull(e.ctx, heroOf(e.ctx.state, e.player)?.id ?? null);
    if (!bigfoot) return;
    // „each fighter" — naozaj každá, aj vlastný sidekick. Karta nerobí rozdiel.
    for (const id of adjacentFighters(e.ctx, bigfoot.spaceId)) dealDamage(e.ctx, id, 1);
  },
};

/** „Move your fighter up to 5 spaces … through spaces containing opposing fighters." */
const hoax: CardEffect = {
  after: (e) => {
    if (!e.fighterId) return;
    askMove(e, {
      fighters: [e.fighterId],
      max: 5,
      through: true,
      label: 'Presuň svoju figúrku až o 5 priestorov (smie prejsť cez súperove figúrky)',
    });
  },
};

/**
 * „Move the Jackalope up to 5 spaces … Then deal 2 damage to any one fighter
 * adjacent to the Jackalope." Poškodenie sa vyberá až PO presune, preto
 * pokračovanie (`follow`) — susedia sa dovtedy nedajú vymenovať.
 */
const jackalopeHorns: CardEffect = {
  scheme: (e) => {
    if (!e.fighterId) return;
    askMove(e, {
      fighters: [e.fighterId],
      max: 5,
      through: true,
      label: 'Presuň Jackalopa až o 5 priestorov (smie prejsť cez súperove figúrky)',
      follow: { kind: 'damageAdjacent', amount: 2, label: 'Sprav 2 poškodenia susednej figúrke' },
    });
  },
};


export const bigfootCards: EffectRegistry = {
  'bigfoot.skirmish': skirmish(2),
  'bigfoot.larger-than-life': {}, // len hodnota, žiadny text
  'bigfoot.crash-through-the-trees': crashThroughTheTrees,
  'bigfoot.it-s-just-your-imagination': feint,
  'bigfoot.savagery': savagery,
  'bigfoot.hoax': hoax,
  'bigfoot.jackalope-horns': jackalopeHorns,
  'bigfoot.disengage': disengage,
  'bigfoot.momentous-shift': momentousShift,
  'bigfoot.feint': feint,
  'bigfoot.regroup': regroup,
};

/** LONER BY NATURE — „na konci ťahu, ak v Bigfootovej zóne nie je súper, smieš potiahnuť kartu". */
export const bigfootSpecial: HeroSpecial = {
  name: 'Loner by Nature',
  endOfTurn: (ctx, player) => {
    const bigfoot = heroOf(ctx.state, player);
    if (!bigfoot) return;
    const map = getMap(ctx);
    const myTeam = ctx.state.players[player]?.team;
    // „opposing fighters in Bigfoot's zone" — do zóny patrí aj jeho vlastný
    // priestor, preto rovnaký priestor rátame ako zdieľanú zónu.
    const enemyNear = ctx.state.fighters.some((f) => {
      if (ctx.state.players[f.owner]?.team === myTeam) return false;
      return f.spaceId === bigfoot.spaceId || shareZone(map, bigfoot.spaceId, f.spaceId);
    });
    if (enemyNear) return;
    askChoice(ctx, {
      kind: 'confirm',
      player,
      source: null,
      special: 'bigfoot',
      label: 'Bigfoot je v zóne sám — potiahnuť kartu? (Loner by Nature)',
      optional: true,
    });
  },
  onConfirm: (ctx, player) => {
    drawCard(ctx, player);
  },
};
